import * as React from 'react';

import ContextLink from '../Common/ContextLink';
import States from 'login-constants/states';

const LoanEstimateSubtitleLink = () => (
  <div>
    Get a more accurate Loan Estimate with a full application. Please keep in mind that the usefulness of a Loan
    Estimate depends in part on the information you provide. It is not too late to{' '}
    <ContextLink isWhite={true} to={States.CREATE_ACCOUNT}>
      submit a full application
    </ContextLink>
  </div>
);
export default LoanEstimateSubtitleLink;
